import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className={`text-2xl font-heading font-bold ${scrolled || !isHome ? 'text-primary-500' : 'text-background-50'}`}>
              快猫短视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : (scrolled || !isHome) ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/90 hover:text-background-50'
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap flex items-center gap-1 ${
                  location.pathname.startsWith('/category')
                    ? 'text-primary-500'
                    : (scrolled || !isHome) ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/90 hover:text-background-50'
                }`}
              >
                分类
                <i className={`ri-arrow-down-s-line text-xs transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {categoryOpen && (
                <div className="absolute top-full left-0 mt-1 bg-background-50 rounded-xl border border-background-200/70 py-2 w-40">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="block px-4 py-2 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : (scrolled || !isHome) ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/90 hover:text-background-50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#"
              className="px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              下载APP
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center"
          >
            <i className={`text-xl ${scrolled || !isHome ? 'text-foreground-800' : 'text-background-50'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-3">
            <Link to="/" className="block px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500">首页</Link>
            <div className="px-4 py-3 text-sm font-medium text-foreground-700">分类</div>
            <div className="pl-6 grid grid-cols-2 gap-1">
              {categories.map((cat) => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} className="block py-2 text-sm text-foreground-600 hover:text-primary-500">
                  {cat.name}
                </Link>
              ))}
            </div>
            <Link to="/about" className="block px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500">关于我们</Link>
            <div className="px-4 pt-3">
              <a href="#" className="inline-block px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer">
                下载APP
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}